export default __webpack_public_path__ + "static/media/factory__32.aa0fa2ce.jpg";